const emitter = new EventTarget();

export { emitter };
